import { ClientProvider } from "@nju/data-access-sales-client";
import { Footer } from "@nju/feature-portal-footer";
import { ClientOrderInfoBox } from "@nju/feature-sales-client";
import { Header, HeaderBackgroundWrapper } from "@nju/feature-sales-header";
import { RespectOrchestratorState } from "@nju/feature-sales-orchestrator";
import { MigrationImpossiblePage } from "@nju/feature-sales-order";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../../components/ClientSideRenderer";

export default function MigrationImpossible() {
  return (
    <LayoutWrapper>
      <HeaderBackgroundWrapper>
        <Header />
      </HeaderBackgroundWrapper>
      <ClientSideOnly>
        <RespectOrchestratorState
          mode="mobile"
          refreshInterval={5000}
          state="LEGACY_MIGRATION_ERROR"
        >
          <ClientProvider>
            <BlockContent>
              <ClientOrderInfoBox />
              <BlockContent grid="narrow">
                <MigrationImpossiblePage />
              </BlockContent>
            </BlockContent>
          </ClientProvider>
        </RespectOrchestratorState>
      </ClientSideOnly>
      <Footer />
    </LayoutWrapper>
  );
}
